import { getErrorCodeFromUnknown } from "./ErrorParsers";

export enum UserServiceErrors {
  InviteAlreadyAccepted = "user-service/invite-already-accepted",
  /**
   * A local user with the given email already exists and is linked to a
   * different identity provider account than the one currently being
   * processed. We refuse to silently re-link to avoid hijacking.
   */
  EmailAlreadyLinkedToDifferentAuthProvider = "user-service/email-already-linked-to-different-auth-provider",
  /**
   * A local user can only be linked to an identity provider account when the
   * provider confirms ownership of the same email address.
   */
  EmailLinkRequiresVerifiedMatchingProviderEmail = "user-service/email-link-requires-verified-matching-provider-email",
  /**
   * The user service of the project (its auth provider) does not implement
   * the requested operation, for example sending a password reset email.
   */
  OperationNotSupported = "user-service/operation-not-supported",
}

const userServiceErrorCodes = new Set<string>(Object.values(UserServiceErrors));

export function getUserServiceErrorCode(
  error: unknown,
): UserServiceErrors | undefined {
  const errorCode = getErrorCodeFromUnknown(error);
  if (!errorCode || !userServiceErrorCodes.has(errorCode)) {
    return undefined;
  }

  return errorCode as UserServiceErrors;
}
